// Typed entry point to the exported content. content.json is generated by export.py from structured canonical sources;
// do not edit it by hand. The worked views are design specifications: screens take their titles, primary actions,
// controls and canonical assistant lines from here, and record any other runtime words as prototype copy (words.ts).
import content from './content.json' with { type: 'json' };

export interface WorkedView { title: string; intent: string; speaker: string | null; asks: string | null; assistant: string | null; controls: string[] }
export interface Flow { name: string; source: string; views: Record<string, WorkedView> }

export const BANNER: string = content.banner;
export const TAG: string = content.tag;
export const LABELS = content.labels;
export const PRICES = content.prices;
export const CORE_CARD: string = content.core_card;
export const F1 = content.f1;
export const FLOWS = content.flows as unknown as Record<string, Flow>;
export const EXCEPTIONS = content.exceptions;
export const UNRESOLVED = content.unresolved;
export const FIXTURE_IDS = content.fixture_ids;
/** A worked view of flow f. */
export const view = (f: number, v: number): WorkedView => FLOWS[String(f)].views[String(v)];
/** A canonical control label: flow f, view v, control i. Throws if the brief has no such control. */
export function control(f: number, v: number, i: number): string {
  const c = view(f, v).controls[i];
  if (!c) throw new Error(`F${f} V${v} has no control ${i}`);
  return c;
}
/** The exception state's canonical title. */
export const excTitle = (key: string): string => EXCEPTIONS.find((e) => e.key === key)?.title ?? key;
export default content;
